import React, { useCallback, useEffect, useRef, useState } from 'react';
import { DEFAULT_RADIO_OPTION } from '../../../constants';
import { MobileSelect } from '../../../SelectComponents/Select';
import { getGroupedOptions, isMultiSelectOptions } from '../../../utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const FiltersSelect = _ref => {
  let {
    filterDefinition,
    filterStatus,
    options,
    selectedOptions,
    onSelectedOptionsChange
  } = _ref;
  const {
    filterId,
    groupSelectedItems,
    isMulti,
    isSearchable
  } = filterDefinition;
  const previousFilterIdRef = useRef();
  const [searchInputValue, setSearchInputValue] = useState('');
  const [groupedOptions, setGroupedOptions] = useState(getGroupedOptions({
    options,
    selectedOptions,
    addSelectedFirst: groupSelectedItems
  }));
  useEffect(() => {
    // Using a ref to compare the previous filterId with the current filterId
    // as we only want to update the grouped options when the filterId changes,
    // and not when the other dependencies used in this effect change.
    if (previousFilterIdRef.current !== filterId) {
      setGroupedOptions(getGroupedOptions({
        options,
        selectedOptions,
        addSelectedFirst: groupSelectedItems
      }));
    }
    previousFilterIdRef.current = filterId;
  }, [filterId, groupSelectedItems, options, selectedOptions]);
  useEffect(() => {
    // When the filterId changes, reset the search input value
    setSearchInputValue('');
  }, [filterId]);
  const handleSearchInputChange = useCallback((newInputValue, meta) => {
    if (meta.action === 'input-change') {
      setSearchInputValue(newInputValue);
    }
  }, []);
  const handleChange = useCallback(newOptionOrOptions => {
    if (isMultiSelectOptions(newOptionOrOptions)) {
      onSelectedOptionsChange({
        filterId,
        options: newOptionOrOptions,
        location: 'mobile'
      });
    } else {
      const optionsWithFallback = newOptionOrOptions ? [newOptionOrOptions] : [];
      onSelectedOptionsChange({
        filterId,
        // If the default `All` radio option is selected, we want to specify that no option is selected
        options: (newOptionOrOptions === null || newOptionOrOptions === void 0 ? void 0 : newOptionOrOptions.value) === DEFAULT_RADIO_OPTION.value ? [] : optionsWithFallback,
        location: 'mobile'
      });
    }
  }, [filterId, onSelectedOptionsChange]);
  return /*#__PURE__*/_jsx(MobileSelect, {
    testId: "mobile-filter-picker-select"
    // If single select and non-empty options, add a default `All` option to the beginning of the options
    ,
    options: !isMulti && options.length > 0 ? [DEFAULT_RADIO_OPTION, ...groupedOptions] : groupedOptions
    // If single select and no selected option, set selected value to the default `All` option
    ,
    selectedOptions: !isMulti && selectedOptions.length === 0 ? [DEFAULT_RADIO_OPTION] : selectedOptions,
    status: filterStatus,
    isMulti: isMulti,
    isSearchable: isSearchable,
    searchInputValue: searchInputValue,
    onSelectionChange: handleChange,
    onSearchInputChange: handleSearchInputChange
  });
};